<template>
  <div>
    <inline-gallery
      v-if="photos"
      :photos="photos"
      :fullscreen="true"
      :fullscreen-open="true"
      :gallery-initial-index="initialIndex"
      :limit-initial-gallery-photos="false"
      @fullscreen-closed="$emit('fullscreen-closed')"
      @slide-changed="$emit('slide-changed', $event)"
    />
  </div>
</template>
<script setup lang="ts">
import { PhotoResult } from '../types'

defineProps<{
  photos: Array<PhotoResult>
  initialIndex: number
}>()
</script>
